import { SxProps, Theme } from '@mui/material/styles';

const ABOUT_SURFACE_COLOR = '#f7f8fb';

export const aboutBodySectionSx: SxProps<Theme> = {
  width: '100vw',
  ml: 'calc(50% - 50vw)',
  mr: 'calc(50% - 50vw)',
  pt: { xs: 3, md: 5 },
  backgroundColor: ABOUT_SURFACE_COLOR,
};

export const aboutCardSx: SxProps<Theme> = {
  border: '1px solid #e4e8ee',
  borderRadius: '10px',
  backgroundColor: ABOUT_SURFACE_COLOR,
  boxShadow: '0 1px 2px rgba(31, 49, 80, 0.03)',
  overflow: 'hidden',
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1.55fr 0.8fr' },
  alignItems: 'stretch',
};

export const whoWeArePaneSx: SxProps<Theme> = {
  px: { xs: 2.5, sm: 3, md: 3.5 },
  py: { xs: 3, md: 3.75 },
  color: '#1f3150',
  backgroundColor: '#ffffff',
};

export const whoWeAreTitleSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  mb: 2.5,
  fontWeight: 600,
  color: '#1f3150',
  fontSize: { xs: '2rem', md: '2.2rem' },
  lineHeight: 1.2,
  '&::before': {
    content: '""',
    display: 'inline-block',
    width: '0.5rem',
    height: '26px',
    borderRadius: '8px',
    backgroundColor: '#1f3150',
    marginRight: '0.5rem',
  },
};

export const whoWeAreContentSx: SxProps<Theme> = {
  color: '#1f3150',
  fontSize: { xs: '1rem', md: '1.06rem' },
  lineHeight: 1.7,
  fontWeight: 400,
  '& p': {
    margin: 0,
    marginBottom: '22px',
  },
  '& p:last-child': {
    marginBottom: 0,
  },
};

export const highlightsPaneSx: SxProps<Theme> = {
  backgroundColor: '#ffffff',
  px: { xs: 2.5, sm: 3, md: 2.5 },
  py: { xs: 3, md: 2.5 },
};

export const highlightsInnerSx: SxProps<Theme> = {
  border: '1px solid #e2e6ef',
  borderTop: '6px solid #1f3e67',
  borderRadius: '16px',
  backgroundColor: '#ffffff',
  boxShadow: '0 4px 12px rgba(20, 42, 72, 0.06)',
  overflow: 'hidden',
  px: { xs: 2.5, md: 3.2 },
  py: { xs: 2.5, md: 3 },
  height: '100%',
};

export const highlightsTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  color: '#1f3150',
  textAlign: 'center',
  mb: 2.5,
  fontSize: { xs: '2rem', md: '2.05rem' },
  lineHeight: 1.22,
};

export const highlightsListSx: SxProps<Theme> = {
  listStyle: 'none',
  m: 0,
  p: 0,
  color: '#1f3150',
  fontSize: { xs: '1rem', md: '1.02rem', lg: '1.06rem' },
  lineHeight: 1.58,
  fontWeight: 400,
  '& li': {
    position: 'relative',
    paddingLeft: '34px',
    marginBottom: '20px',
  },
  '& li:last-child': {
    marginBottom: 0,
  },
  '& li::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: '0.1em',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '1.5px solid #b8773e',
    backgroundColor: '#f4f4f4',
    boxShadow: '0 1px 2px rgba(18, 34, 61, 0.15)',
  },
  '& li::after': {
    content: '"\\2713"',
    position: 'absolute',
    left: '10px',
    top: 'calc(0.22em + 10px)',
    transform: 'translate(-50%, -50%)',
    color: '#b8773e',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1,
    pointerEvents: 'none',
  },
};

export const offerSectionSx: SxProps<Theme> = {
  pt: { xs: 5, md: 6 },
  paddingBottom: { xs: 4, md: 6 },
  backgroundColor: '#ffffff',
};

export const offerSectionTitleSx: SxProps<Theme> = {
  textAlign: 'center',
  color: '#1f3150',
  fontWeight: 600,
  mb: { xs: 3.5, md: 4.5 },
  fontSize: { xs: '2rem', md: '2.8rem' },
  lineHeight: 1.15,
};

export const offerGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  gap: { xs: 3.5, md: 4.5 },
};

export const offerCardSx: SxProps<Theme> = {
  color: '#1f3150',
};

export const offerImageWrapSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  borderRadius: '4px',
  overflow: 'hidden',
  mb: 1.5,
};

export const offerTitleSx: SxProps<Theme> = {
  color: '#b18a53',
  fontWeight: 600,
  fontSize: { xs: '1.45rem', md: '1.6rem' },
  lineHeight: 1.25,
  mb: 0.75,
  paddingTop: { xs: 0, md: 1.5, lg: 2 },
};

export const offerDescriptionSx: SxProps<Theme> = {
  color: '#1f3150',
  fontWeight: 400,
  fontSize: { xs: '1rem', md: '0.98rem' },
  lineHeight: 1.65,
  whiteSpace: 'pre-line',
};
